import { Box, Text } from "@radix-ui/themes";
import { DashboardWidget } from "@/types/breeze/Dashboard";

interface Props {
  widget: DashboardWidget;
}

export function MarkdownWidget({ widget }: Props) {
  const config = parseConfig(widget.config_json);
  const body = config?.body ?? "";

  return (
    <Box p="4" style={{ height: "100%", overflow: "auto" }}>
      <Text size="2" weight="medium" mb="2" asChild>
        <div>{widget.title}</div>
      </Text>
      <Text size="2" asChild>
        <div style={{ whiteSpace: "pre-wrap" }}>{body}</div>
      </Text>
    </Box>
  );
}

function parseConfig(configJson: string | null): { body?: string } | null {
  if (!configJson) return null;
  try {
    return JSON.parse(configJson);
  } catch {
    return null;
  }
}
